import { render, staticRenderFns } from "./AdminListProjects.vue?vue&type=template&id=06c83e83&scoped=true&lang=html&"
import script from "./AdminListProjects.vue?vue&type=script&lang=js&"
export * from "./AdminListProjects.vue?vue&type=script&lang=js&"
import style0 from "./AdminListProjects.vue?vue&type=style&index=0&id=06c83e83&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c83e83",
  null
  
)

export default component.exports